var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "leaders"
  }, [_c('div', {
    staticClass: "leaders-main"
  }, [_c('div', {
    staticClass: "leaders-head"
  }, [_c('div', {
    staticClass: "leaders-head-main"
  }, [_c('img', {
    attrs: {
      "src": require('@images/leaders-head.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "leaders-head__title"
  }, [_vm._v("Last Results")])]), _c('div', {
    staticClass: "leaders-list"
  }, [_c('div', {
    staticClass: "leaders-list-main"
  }, [_vm.personalList ? [_vm.personalList.length > 0 ? _vm._l(_vm.personalList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "leaders-item"
    }, [_c('div', {
      staticClass: "leaders-item__img"
    }, [item.avatar ? _c('img', {
      attrs: {
        "src": item.avatar,
        "alt": ""
      }
    }) : _c('m-head-img', {
      attrs: {
        "name": item,
        "bgColor": item.head_color
      }
    })], 1), _c('div', {
      staticClass: "leaders-item-info"
    }, [_c('div', {
      staticClass: "leaders-item__title"
    }, [_vm._v(_vm._s(item.firstname) + " " + _vm._s(item.lastname))]), _c('div', {
      staticClass: "leaders-item-reward",
      class: index == 0 ? 'st' : index == 1 ? 'nd' : index == 2 ? 'rd' : 'th'
    }, [index <= 2 ? _c('svg-icon', {
      attrs: {
        "name": "icon-leaders"
      }
    }) : _c('svg-icon', {
      attrs: {
        "name": "icon-per"
      }
    }), _vm._v(" " + _vm._s(index == 0 ? "1st" : index == 1 ? "2nd" : index == 2 ? "3rd" : `${index + 1}th`) + " ")], 1)]), _c('div', {
      staticClass: "leaders-item-reward"
    }, [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-coin.png'),
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.coin)) + " ")])]);
  }) : [_c('div', {
    staticClass: "leaders__empty"
  }, [_vm._v("There's nothing here")])]] : [_vm._m(0)]], 2)]), _c('div', {
    staticClass: "leaders-user user"
  }, [_c('div', {
    staticClass: "leaders-item__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "leaders-item-info"
  }, [_c('div', {
    staticClass: "leaders-item__title"
  }, [_vm._v(_vm._s(_vm.userInfo.firstname) + " " + _vm._s(_vm.userInfo.lastname))]), _c('div', {
    staticClass: "leaders-item-reward",
    class: _vm.userRank == 1 ? 'st' : _vm.userRank == 2 ? 'nd' : _vm.userRank == 3 ? 'rd' : 'th'
  }, [_vm.userRank <= 3 ? _c('svg-icon', {
    attrs: {
      "name": "icon-leaders"
    }
  }) : _c('svg-icon', {
    attrs: {
      "name": "icon-per"
    }
  }), _vm._v(" " + _vm._s(_vm.userRank == 1 ? "1st" : _vm.userRank == 2 ? "2nd" : _vm.userRank == 3 ? "3rd" : `${_vm.userRank}th`) + " ")], 1)]), _c('div', {
    staticClass: "leaders-item-reward"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-coin.png'),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.fmt_pre(_vm.userInfo.coin)) + " ")])])]), _c('m-menu')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]);
}];
export { render, staticRenderFns };